const Reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_WAITING_SUPPORT_COUNT':
      return { ...state, waitingSupportsCount: action.payload }
    case 'LIST_SUPPORT_REQUESTS':
      return { ...state, supportRequests: action.payload }
    case 'CLEAR_SUPPORT_REQUESTS':
      return { ...state, supportRequests: [] }
    case 'GET_SUPPORT_REQUEST_DETAIL':
      return { ...state, supportRequestDetail: action.payload }
    case 'CLEAR_SUPPORT_REQUEST_DETAIL':
      return { ...state, supportRequestDetail: null }
    default:
      return state
  }
}
export default Reducer
